// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Tooltip" (14031:67857). Do not edit.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const tooltipContract = {
    component: 'Tooltip',
    nodeId: '14031:67857',
    section: '[Web] Primitives',
    composes: [] as readonly ContractComposition[],
    stateAxis: null,
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [
        { note: '14 labels with their own ink or style', count: 1 },
        { note: '3 labels with their own ink or style', count: 1 },
        { note: '5 labels with their own ink or style', count: 1 },
        {
            note: 'primaryAxisAlignItems MAX on a row that hugs — no slack to align in, so the file states an alignment it does not draw',
            count: 9,
            property: 'primaryAxisAlignItems',
            stated: 'MAX',
        },
        {
            note: 'textAlignHorizontal RIGHT on a HUG text — renders left, so the file states an alignment it does not draw',
            count: 9,
            property: 'textAlignHorizontal',
            stated: 'RIGHT',
        },
    ] as readonly ContractDisagreement[],
    textStyleIds: [
        'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
        'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
    ],
    props: {
        variant: { kind: 'enum', values: ['Simple', 'Complex', 'four-ranges', 'two-ranges'] },
    },
    variants: {
        'variant=Complex': {
            container: 'bg-background-elevation rounded-common px-s py-s gap-xs items-start',
            label: 'text-content-muted text-left',
            icon: 'text-graphics-teal',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                '8': 'text-content-default text-right',
                '28': 'text-content-default text-right',
                '32': 'text-content-default text-right',
                '02:15': 'text-content-muted text-left',
                'line_item': 'items-start',
                'Temperature': 'text-content-muted text-left w-[5rem]',
                'value': 'gap-2xs items-center',
                '°C': 'text-content-muted text-left',
                'line_item 2': 'items-start',
                'Dew point': 'text-content-muted text-left w-[5rem]',
                'value 2': 'gap-2xs items-center',
                'line_item 3': 'items-start',
                'Apron temp': 'text-content-muted text-left w-[5rem]',
                'value 3': 'gap-2xs items-center',
                '°C 2': 'text-content-muted text-left',
                'line_item 4': 'items-start justify-between',
                'Rain': 'text-content-muted text-left w-[5rem]',
                'value 4': 'gap-2xs items-center',
                '0.6': 'text-content-default text-left',
                'mm/h': 'text-content-muted text-right',
                'line_item 5': 'items-start',
                'FWP': 'text-content-muted text-left w-[5rem]',
                'value 5': 'gap-xs items-center',
                'dot': 'bg-graphics-teal rounded-common w-[0.75rem] h-[0.75rem]',
                'Heavy FZRA': 'text-content-default text-right',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                '8': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                '28': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                '32': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                '02:15': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'Temperature': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                '°C': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'Dew point': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'Apron temp': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                '°C 2': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'Rain': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                '0.6': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'mm/h': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'FWP': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'Heavy FZRA': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
            } as Record<string, string>,
            composes: [],
        },
        'variant=four-ranges': {
            container: 'bg-background-elevation rounded-common px-s py-s gap-s items-start',
            label: 'text-content-default text-left',
            icon: 'text-graphics-pink',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'Thunderstorm probability': 'text-content-default text-left',
                'ranges': 'gap-xs items-start',
                'range-item': 'gap-xs items-center',
                'dot': 'bg-graphics-teal rounded-common w-[0.75rem] h-[0.75rem]',
                'Unlikely, yet possible': 'text-content-default text-left',
                'range-item 2': 'gap-xs items-center',
                'dot 2': 'bg-graphics-blue rounded-common w-[0.75rem] h-[0.75rem]',
                'Possible': 'text-content-default text-left',
                'range-item 3': 'gap-xs items-center',
                'dot 3': 'bg-graphics-violet rounded-common w-[0.75rem] h-[0.75rem]',
                'Likely': 'text-content-default text-left',
                'range-item 4': 'gap-xs items-center',
                'dot 4': 'bg-graphics-pink rounded-common w-[0.75rem] h-[0.75rem]',
                'Highly probable': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'Thunderstorm probability': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'Unlikely, yet possible': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'Possible': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'Likely': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'Highly probable': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
            } as Record<string, string>,
            composes: [],
        },
        'variant=Simple': {
            container: 'bg-background-elevation rounded-common px-s py-s items-start',
            label: 'text-content-default text-left',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                Accept: 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                Accept: 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
            } as Record<string, string>,
            composes: [],
        },
        'variant=two-ranges': {
            container: 'bg-background-elevation rounded-common px-s py-s gap-s items-start',
            label: 'text-content-default text-left',
            icon: 'text-graphics-pink',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'Thunderstorm probability': 'text-content-default text-left',
                'ranges': 'gap-xs items-start',
                'range-item': 'gap-xs items-center',
                'dot': 'bg-graphics-violet rounded-common w-[0.75rem] h-[0.75rem]',
                'Likely': 'text-content-default text-left',
                'range-item 2': 'gap-xs items-center',
                'dot 2': 'bg-graphics-pink rounded-common w-[0.75rem] h-[0.75rem]',
                'Highly probable': 'text-content-default text-left',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                'Thunderstorm probability': 'S:0fa036ddc0a173a340137517ff39c483dfbade3d,',
                'Likely': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
                'Highly probable': 'S:3379f3e69d79bb20e0ffc8221eaedd982424986d,',
            } as Record<string, string>,
            composes: [],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
